module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"inicio":"Inicio","contacto":"Contacto","ubicacion":"Ubicación"},"en":{"inicio":"Home","contacto":"Contact","ubicacion":"Location"}}')
  delete Component.options._Ctor
}
